import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Button from "components/particles/primary-button";
import { Container, StyledReactModal } from "./style";
import deleteIcon from "assets/images/delete.svg";

import { useForm } from "react-hook-form";
import { DietaryChoiceDTO } from "utils/helpers/models/dietaryChoice.dto";
import { useDietaryChoice } from "containers/setting/CMS/dietary-choise/useHook";
import FormErrorMessage from "components/particles/forms/form-error-message";
import { setModalClosed } from "store/user-slice";

import { useSelector } from "react-redux";
import { dispatch } from "store";

interface DietaryChoiceModelProps {
  id: number;
  data: any;
}

const DietaryChoicePopup: FC<DietaryChoiceModelProps> = ({ id, data }) => {
  const [formData, setFormData] = useState<DietaryChoiceDTO>(
    new DietaryChoiceDTO()
  );
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm<DietaryChoiceDTO>({ defaultValues: new DietaryChoiceDTO() });
  const { dietaryChoiceModalIsOpen } = useSelector((state: any) => state.user);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      fontSize: "2rem",
      width: "68.5rem",
      height: "50vh",
      borderRadius: "3rem",
    },
  };
  const { PostDietaryChoice, putDietaryChoice } = useDietaryChoice();
  function closeModal() {
    dispatch(setModalClosed("Dietary Choice"));
  }

  useEffect(() => {
    if (id === 0) {
      const defaultDto = new DietaryChoiceDTO();
      setFormData(defaultDto);
      setValue("question", defaultDto.question);
      setValue("description", defaultDto.description ?? "");
      setValue("options", defaultDto.options);
      return;
    }
    if (!data) return;
    const question = data.question ?? "";
    const description = data.description ?? "";
    const rawOptions = data.options;
    const optionsArray: string[] = Array.isArray(rawOptions)
      ? rawOptions.length
        ? [...rawOptions]
        : [""]
      : typeof rawOptions === "object" && rawOptions !== null
        ? Object.values(rawOptions).filter((v): v is string => typeof v === "string")
        : [""];
    if (!optionsArray.length) optionsArray.push("");

    const nextFormData: DietaryChoiceDTO = {
      ...new DietaryChoiceDTO(),
      question,
      description,
      options: optionsArray,
    };
    setFormData(nextFormData);
    setValue("question", question);
    setValue("description", description);
    setValue("options", optionsArray);
  }, [data, id]);

  const handleAdd = () => {
    const nextOptions = [...formData.options, ""];
    setValue("options", nextOptions);
    setFormData((prev) => ({ ...prev, options: nextOptions }));
  };

  const handleRemove = (index: number) => {
    const nextOptions = formData.options.filter((_, i) => i !== index);
    if (nextOptions.length === 0) nextOptions.push("");
    setValue("options", nextOptions);
    setFormData((prev) => ({ ...prev, options: nextOptions }));
  };

  const onSubmit = (data: DietaryChoiceDTO) => {
    if (id) {
      putDietaryChoice(id, data);
    } else {
      PostDietaryChoice(data);
    }
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setValue(name, value);
    setFormData({ ...formData, [name]: value });
  };

  const handleOptionsChange = (event: any, index: number) => {
    const { value } = event.target;
    const nextOptions = [...formData.options];
    nextOptions[index] = value;
    setValue("options", nextOptions);
    setFormData((prev) => ({ ...prev, options: nextOptions }));
  };

  return (
    <StyledReactModal
      isOpen={dietaryChoiceModalIsOpen}
      onRequestClose={closeModal}
      // style={customStyles}
      contentLabel="Example Modal"
    >
      <div style={{display: "flex", justifyContent: "end",flexDirection: "column"}}>
        <div>
          <button className="close-button" onClick={closeModal}>
            <img src={close} alt="img" />
          </button>
        </div>
        <Container
          className="p-custom-scrollbar-8 custom-scrollbar"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="popup-title">
            <h1>Dietary Choice</h1>
          </div>
          <div className="add-ingredient-container ">
            <div>
              <input
                type="text"
                placeholder="Question"
                {...register("question", {
                  required: true,
                })}
                onChange={handleChange}
              />
              <FormErrorMessage error={errors.question} />
            </div>
            <input
              type="text"
              placeholder="Description"
              {...register("description")}
              onChange={handleChange}
            />
            {formData.options.map((field: string, index: number) => (
              <div key={index} className="input-container">
                <input
                  type="text"
                  placeholder={`Answer ${index + 1}`}
                  className="input"
                  {...register(`options.${index}`, { required: true })}
                  onChange={(e) => handleOptionsChange(e, index)}
                />
                {index === 0 ? (
                  <Button
                    title="+Add"
                    width="11rem"
                    backgroundcolor="var(--reset-button)"
                    fill="true"
                    onclick={handleAdd}
                  />
                ) : (
                  <div
                    className="delete-container"
                    onClick={() => handleRemove(index)}
                  >
                    <img src={deleteIcon} alt="img" />
                  </div>
                )}
              </div>
            ))}
          <div className="add-button">
            <Button
             
              title={id === 0 ? "Add" : "Update"}
              width="100%"
              backgroundcolor="var(--primary)"
              fill="true"
            />
          </div>
          </div>

        </Container>
      </div>
    </StyledReactModal>
  );
};

export default DietaryChoicePopup;
